import { types } from 'mobx-state-tree';

const Strategies = types
  .model('Strategies', {
    properties: types.frozen,
  })
  .views(self => ({
    get getProperties() {
      return self.properties;
    },
  }))
  .actions(self => {
    const setProperties = (strategyType, property, value) => {
      const newProperties = { ...self.properties };
      newProperties[property] = value;
      self.properties = newProperties;
    };
    return {
      setProperties,
    };
  });

export default Strategies;
